import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';

/** Fond hlasov prihláseného občana: koľko má vložených a koľko mu zostáva. */
export const meGetVoteTokensSummary = createQueryFn(
  QueryNameSpace.meGetVoteTokensSummary,
  async () => {
    return await DigiobcanApi.meGetVoteTokensSummary();
  },
);
